import gql from 'graphql-tag';

// Avisos del usuario logueado. El backend decide cuáles ve con el usuario del token (AlcanceUsuario), no con
// argumentos: por eso estas consultas no mandan usuario ni cliente.

export const NO_LEIDOS = gql`
  query AvisosNoLeidos {
    avisos {
      noLeidos
    }
  }
`;

export const MIS_AVISOS = gql`
  query MisAvisos($query: QueryInput!, $soloNoLeidos: Boolean) {
    avisos {
      misAvisos(query: $query, soloNoLeidos: $soloNoLeidos) {
        totalItems
        items {
          id
          tipo
          titulo
          mensaje
          referenciaId
          fechaCreacion
          leido
        }
      }
    }
  }
`;
